import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { keyById } from '@mews/fp';
import { CREATE_RESERVATION_GROUP_SUCCEEDED, FETCH_RESERVATION_GROUP_SUCCEEDED } from './actionTypes';
import { FetchReservationGroupsResponse } from './responseType';

const reservationGroupsSlice = createSlice({
    name: 'reservationGroups',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            FETCH_RESERVATION_GROUP_SUCCEEDED,
            (state, { payload: { reservationGroups } }: PayloadAction<FetchReservationGroupsResponse>) =>
                keyById(reservationGroups)
        );
        builder.addCase(
            CREATE_RESERVATION_GROUP_SUCCEEDED,
            (
                state,
                {
                    payload: { reservationGroups },
                }: PayloadAction<FetchReservationGroupsResponse, typeof CREATE_RESERVATION_GROUP_SUCCEEDED>
            ) => keyById(reservationGroups)
        );
    },
});

export const reservationGroupsReducer = combineReducers({
    data: reservationGroupsSlice.reducer,
});
